/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingselectplacedescription3Inputs */

const en_crosspostingselectplacedescription3 = /** @type {(inputs: Crosspostingselectplacedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a place to connect its social accounts and start posting.`)
};

const de_crosspostingselectplacedescription3 = /** @type {(inputs: Crosspostingselectplacedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle einen Ort, um seine Social-Media-Konten zu verbinden und zu posten.`)
};

/**
* | output |
* | --- |
* | "Select a place to connect its social accounts and start posting." |
*
* @param {Crosspostingselectplacedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingselectplacedescription3 = /** @type {((inputs?: Crosspostingselectplacedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingselectplacedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingselectplacedescription3(inputs)
	return de_crosspostingselectplacedescription3(inputs)
});
export { crosspostingselectplacedescription3 as "crosspostingSelectPlaceDescription" }